export const shouldAutoScrollCoachTimeline = ({ initial, newTail, wasAtBottom }) => (
  Boolean(initial) || (Boolean(newTail) && Boolean(wasAtBottom))
);

const normalizedId = value => String(value || '').trim();

export const coachToastFocusOptions = targetId => {
  const id = normalizedId(targetId);
  return id ? { focusTimelineEntryId: id } : {};
};

export const coachReadyToastTargetId = (key, recommendationOrAnswer) => {
  const recommendationId = typeof recommendationOrAnswer === 'object'
    ? (recommendationOrAnswer?._id || recommendationOrAnswer?.id)
    : null;
  if (recommendationId) return normalizedId(recommendationId);
  const normalizedKey = normalizedId(key);
  return normalizedKey.startsWith('coach-ready:')
    ? normalizedKey.slice('coach-ready:'.length)
    : normalizedKey;
};

export const resolveCoachTimelineFocusEntry = (timeline = [], targetId) => {
  const id = normalizedId(targetId);
  if (!id) return null;
  const directInsight = timeline.find(item => item?.kind === 'insight' && normalizedId(item.id) === id);
  if (directInsight) return directInsight;
  const generatedReply = timeline.find(item => (
    item?.kind === 'insight'
    && Array.isArray(item.replyToEventIds)
    && item.replyToEventIds.some(eventId => normalizedId(eventId) === id)
  ));
  if (generatedReply) return generatedReply;
  return timeline.find(item => normalizedId(item?.id) === id) || null;
};

export const alignCoachTimelineTarget = (history, target, inset = 8) => {
  if (!history?.getBoundingClientRect || !target?.getBoundingClientRect) return null;
  const historyTop = history.getBoundingClientRect().top;
  const targetTop = target.getBoundingClientRect().top;
  const maxScrollTop = Math.max(0, Number(history.scrollHeight || 0) - Number(history.clientHeight || 0));
  const desired = Number(history.scrollTop || 0) + targetTop - historyTop - Math.max(0, Number(inset || 0));
  const nextScrollTop = Math.max(0, Math.min(maxScrollTop, desired));
  history.scrollTop = nextScrollTop;
  return nextScrollTop;
};
